module.exports = {
  secret: {
    development: 'cgur9ZbVYeWMShNm3dbn',
    staging: 'mGa98h9ZJsayBmFIgVm5',
    production: 'OmuU3NDVQW297mqSxfbf'
  }
}
